import React from "react";
import {Box} from "@mui/material";
import LoadingLottieAnimation from "../../../components/app-specific/lottie-animations/loading";

const PartFormQualificationLoadingIndicator = () => (
    <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", py: 3, width: "100%"}}>
        <LoadingLottieAnimation width={300}/>
    </Box>
);

export default PartFormQualificationLoadingIndicator;
